import { useSearchParams, useNavigate } from 'react-router-dom';
import { Mail, ArrowRight, RefreshCw, ShieldCheck, Clock, Inbox } from 'lucide-react';
import logo from '../assets/Logo.png';

export const RegistroExitosoPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#4CAF50]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#2196F3]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-lg w-full">
        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-10 text-center">
          {/* Logo */}
          <img src={logo} alt="ConfiFarma" className="h-24 mx-auto mb-6" />

          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            ¡Registro exitoso!
          </h1>

          <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-[#4CAF50]/10 text-[#0d5c3b] mb-4">
            <span className="w-2 h-2 bg-[#4CAF50] rounded-full mr-2 animate-pulse"></span>
            Código de verificación enviado
          </div>

          <p className="text-gray-600 text-lg mb-2">
            Te hemos enviado un código de verificación a:
          </p>

          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gray-50 border border-gray-200 mb-8">
            <Mail className="w-5 h-5 text-[#2196F3]" />
            <span className="font-semibold text-gray-900">{email}</span>
          </div>

          {/* Pasos */}
          <div className="rounded-2xl bg-gradient-to-br from-[#4CAF50]/5 to-[#2196F3]/5 border border-[#4CAF50]/10 p-6 mb-8 text-left">
            <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
              <Clock className="w-5 h-5 text-[#2196F3]" />
              ¿Qué sigue?
            </h3>
            <ol className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 bg-gradient-to-br from-[#4CAF50] to-[#2196F3] text-white rounded-full flex items-center justify-center text-xs font-bold shadow-sm">1</span>
                <div>
                  <p className="text-gray-700 text-sm"><strong>Revisa tu correo</strong></p>
                  <p className="text-gray-500 text-xs">Busca en tu bandeja de entrada. Si no lo ves, revisa la carpeta de <strong>Spam o Correo no deseado</strong>.</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 bg-gradient-to-br from-[#4CAF50] to-[#2196F3] text-white rounded-full flex items-center justify-center text-xs font-bold shadow-sm">2</span>
                <div>
                  <p className="text-gray-700 text-sm"><strong>Usa el código de 6 dígitos</strong></p>
                  <p className="text-gray-500 text-xs">En el correo encontrarás un código y un enlace directo para verificar tu cuenta.</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 bg-gradient-to-br from-[#4CAF50] to-[#2196F3] text-white rounded-full flex items-center justify-center text-xs font-bold shadow-sm">3</span>
                <div>
                  <p className="text-gray-700 text-sm"><strong>Crea tu contraseña</strong></p>
                  <p className="text-gray-500 text-xs">Ingresa el código y establece una contraseña segura para activar tu cuenta.</p>
                </div>
              </li>
            </ol>
          </div>

          {/* Botón principal */}
          <button
            onClick={() => navigate(`/verificar-cuenta?email=${encodeURIComponent(email)}`)}
            className="w-full bg-gradient-to-r from-[#4CAF50] to-[#2196F3] hover:opacity-90 text-white py-4 rounded-2xl font-semibold transition-all duration-300 hover:scale-[1.02] hover:shadow-lg flex items-center justify-center gap-2 mb-4"
          >
            Ingresar código de verificación
            <ArrowRight className="w-5 h-5" />
          </button>

          {/* Reenviar código */}
          <button
            onClick={() => navigate(`/verificar-cuenta?email=${encodeURIComponent(email)}`)}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-[#2196F3] hover:text-[#1976D2] transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            ¿No recibiste el correo? Reenviar código
          </button>
        </div>

        {/* Footer info */}
        <div className="mt-6 flex flex-col items-center gap-3 text-sm text-gray-500">
          <div className="flex items-center gap-2">
            <Inbox className="w-4 h-4 text-[#4CAF50]" />
            <span>Revisa también tu carpeta de Spam</span>
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-[#2196F3]" />
            <span>Tus datos están protegidos con encriptación SSL</span>
          </div>
        </div>
      </div>
    </div>
  );
};
